module.exports = __webpack_public_path__ + "img/_attach_left.c031db35.svg";